import React, { useCallback, useContext, useEffect, useState } from "react";
import InnerLayout from "../../components/layouts/inner-layout";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import DynamicTable from "../../components/tables/dynamic-table1";
import LoadingSpinner from "../../components/helper-components/loading-spinner";
import {
  productDeleteAction,
  productTableAction,
} from "../../redux/actions/product-action";
import ProductFilter from "../../components/tables/table-filter/product-filter";
import { itemGroupListAction } from "../../redux/actions/general-action";
import errorToast from "../../components/helper-components/error-toast";
import { DataContext } from "../../components/layouts/main-layout";
import { useHotkeys } from "react-hotkeys-hook";
import { downloadAllTemplates } from "../../components/helper-components/helper-function";
import ProductImportCsvModal from "../../components/product-information/product-import-csv-modal";

const ProductTable = () => {
  const [heading, setHeading] = useState([]);

  const { permissionFn } = useContext(DataContext);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const dispatch = useDispatch();
  const [itemGroup, setItemGroup] = useState([]);
  const [itemsList, setItemsList] = useState([]);
  const [dataCount, setDataCount] = useState(0);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [showFilter, setShowFilter] = useState(false);
  const [reload, setReload] = useState(false);
  const [pageSize, setPageSize] = useState(10);
  const [filterData, setFilterData] = useState({
    sort_by: "",
    sort_order: "",
    // selectColumn: "item_name",
    selectColumn: "",
    from: "",
    to: "",
    stock: "",
  });

  useEffect(() => {
    dispatch(itemGroupListAction(onitemGroupSuccess, onitemGroupError));
    const data = localStorage.getItem("ModPermission");
    if (data) {
      const parsed = JSON.parse(data);
      const cusData = parsed.find((obj) => obj?.product_list);
      if (cusData?.product_list) {
        setHeading(cusData.product_list);
      }
    }
  }, []);

  const onitemGroupSuccess = (data) => {
    setItemGroup(
      data?.data?.itemgrouplist?.map((item) => {
        return { label: item?.itemgroup, value: item?.id };
      })
    );
  };
  const onitemGroupError = (data) => {
    errorToast(data?.message);
  };
  useEffect(() => {
    dispatch(
      productTableAction(
        {
          pageNumber: currentPage,
          pageSize: pageSize,
          filterData,
        },
        onSuccess,
        onError
      )
    );
  }, [currentPage, pageSize, filterData, reload]);
  const onSuccess = (data) => {
    setError(false);
    setLoading(false);
    setItemsList(data?.data?.getItemsList);
    setDataCount(data?.data?.totalCount);
  };
  const onError = (data) => {
    setError(true);
    setLoading(false);
  };

  const navigate = useNavigate();

  const tableBodyData = itemsList?.map((item) => {
    return {
      id: item?.item_id,
      item_code:
        <span className="fw_500">{item?.item_code ?? "--"}</span> ?? "--",
      item_name: item?.item_name ? item?.item_name : "--",
      item_generic_name: item?.item_generic_name
        ? item?.item_generic_name
        : "--",
      // item_rack_location: item?.item_rack_location ?? "--",
      item_status: (
        <span
          className={`inline-block px-2 py-1 rounded text-white text-xs font-medium ${
            item?.is_draft
              ? "bg-disabled-color"
              : item?.is_active
              ? "bg-027A48"
              : "bg-F94B4B"
          }`}
        >
          {item?.is_draft ? "Draft" : item?.is_active ? "Active" : "Inactive"}
        </span>
      ),
      item_approved: (
        <span
          className={`inline-block px-2 py-1 rounded text-white text-xs font-medium ${
            item?.is_item_approved ? "bg-027A48" : "bg-pending-color"
          }`}
        >
          {item?.is_item_approved ? "Approved" : "Pending"}
        </span>
      ),
      total_sellable_quantity: item?.total_sellable_quantity ?? "--",
    };
  });
  const paginationProps = {
    pageSize: pageSize,
    setPageSize: setPageSize,
    dataCount: dataCount,
    setCurrentPage: setCurrentPage,
    currentPage: currentPage,
  };
  const handleFilterClick = useCallback(() => {
    setShowFilter((prevShowFilter) => !prevShowFilter);
  }, []);

  const filterby = showFilter ? (
    <ProductFilter
      itemGroup={itemGroup}
      filterData={filterData}
      setFilterData={setFilterData}
      setShowFilter={setShowFilter}
    />
  ) : null;
  useHotkeys("escape", () => {
    setShowFilter(false);
  });

  return (
    <InnerLayout
      list={true}
      module="product"
      permissionFn={permissionFn}
      onclkFn={() => navigate("/add-product")}
      title="All Items"
      backBtn={true}
    >
      {loading ? (
        <LoadingSpinner />
      ) : error ? (
        <></>
      ) : (
        <DynamicTable
          is_checkbox_req={false}
          onClickItemFn={(id) => navigate(`/view-product/${id}`)}
          list={true}
          onclkFn={() => {
            navigate("/add-product");
          }}
          permissionFn={permissionFn}
          module={"product"}
          path="product"
          id_name="item_id"
          reload={reload}
          setReload={setReload}
          loading={loading}
          setLoading={setLoading}
          deleteAction={productDeleteAction}
          label="Item"
          showFilter={showFilter}
          filterFn={handleFilterClick}
          setFilterData={setFilterData}
          filterData={filterData}
          paginationProps={paginationProps}
          tableHeading={heading}
          tableBodyData={tableBodyData}
          placeholder="Search"
          filterBy={filterby}
          initialFilter={{
            sort_by: "",
            sort_order: "",
            selectColumn: "item_name",
            from: "",
            to: "",
            stock: "",
          }}
          importCsv={true}
          onclkCSV={() => {
            setIsModalOpen(true);
          }}
          onclkCscDown={() => {
            downloadAllTemplates(productTables);
          }}
        />
      )}
      <ProductImportCsvModal
        reload={reload}
        setReload={setReload}
        productTables={productTables}
        isModalOpen={isModalOpen}
        setIsModalOpen={setIsModalOpen}
      />
    </InnerLayout>
  );
};

export default ProductTable;
const tableHeading = [
  {
    label: "ITEM CODE",
    value: "item_code",
    display: true,
    column: true,
  },
  {
    label: "ITEM NAME",
    value: "item_name",
    display: true,
    column: true,
  },
  {
    label: "GENERIC NAME",
    value: "item_generic_name",
    display: true,
    column: true,
  },

  {
    label: "Avail. Qty",
    value: "total_sellable_quantity",
    display: false,
    column: false,
  },

  {
    label: "Status",
    value: "item_status",
    display: true,
    column: true,
  },

  {
    label: "Is Approved?",
    value: "item_approved",
    display: true,
    column: true,
  },

  {
    label: "",
    value: "",
    column: false,
  },
];
export const productTables = [
  {
    index: 0,
    documentType: "itemData",
    filename: "",
    expectedHeaders: [
      "item_type",
      "item_name",
      "item_price_list",
      "item_generic_name",
      "item_group",
      "item_barcode",
      "item_uom",
      "item_unit_price",
      "item_description",
      "manage_item_by",
      "item_manufacturer",
      "item_shipping_type",
      "item_sector",
      "item_schedule",
      "item_hsn",
      "item_categeory",
      "country",
      "item_code",
      "active_from",
      "active_to",
      "inactive_from",
      "inactive_to",
      "is_active",
      "item_tax_category",
    ],
  },
  {
    index: 1,
    documentType: "PackingInformation",
    filename: "",
    expectedHeaders: [
      "item_code",
      "item_packing_type_name",
      "item_packing_name",
      "item_carton_type_name",
    ],
  },
  {
    index: 2,
    documentType: "PurchaseData",
    filename: "",
    expectedHeaders: [
      "item_code",
      "item_pur_preferred_vendor",
      "item_pur_mfg_catalog_no",
      "item_pur_purchasing_uom_name",
      "item_pur_per_purchasing_unit",
      "item_pur_packing_uom_name",
      "item_pur_quantity_per_package",
      "item_pur_length",
      "item_pur_width",
      "item_pur_height",
      "item_pur_volume",
      "item_pur_weight",
      "item_pur_customs_group",
      "item_pur_measurement_unit",
      "item_pur_factor_1",
      "item_pur_factor_2",
      "item_pur_factor_3",
      "item_pur_factor_4",
      "item_pur_preferred_vendor_id",
      "item_pur_purchasing_uom_name_id",
    ],
  },
  {
    index: 3,
    documentType: "SalesData",
    filename: "",
    expectedHeaders: [
      "item_code",
      "item_sales_uom_name",
      "item_sales_uom_name_id",
      "item_sales_packing_uom_name",
      "item_sales_quantity_per_package",
      "item_per_sales_unit",
      "item_sales_length",
      "item_sales_width",
      "item_sales_height",
      "item_sales_volume",
      "item_sales_weight",
      "item_sales_measurement_unit",
      "item_sales_factor_1",
      "item_sales_factor_2",
      "item_sales_factor_3",
      "item_sales_factor_4",
      "is_draft",
    ],
  },
  {
    index: 4,
    documentType: "InventoryData",
    filename: "",
    expectedHeaders: [
      "item_code",
      "item_set_gl_account",
      "item_uom_name",
      "item_valuation_method",
      "item_cost",
      "item_weight",
      "item_purchasing_uom",
      "item_minimun_purchasing",
      "item_maximum_purchasing",
      "manage_inventory_by_warehouse",
    ],
  },
  {
    index: 5,
    documentType: "PlanningData",
    filename: "",
    expectedHeaders: [
      "item_code",
      "item_order_interval",
      "item_order_multiple",
      "item_minimum_order_quantity",
      "item_checking_rule",
    ],
  },
  {
    index: 6,
    documentType: "DiscountData",
    filename: "",
    expectedHeaders: [
      "item_code",
      "item_min_discount",
      "item_max_discount",
      "item_on_purchasing_qauntity",
      "item_customer_reward_qauntity",
      "item_customer_reward_uom_id",
      "item_on_purchasing_unit_id",
    ],
  },
  {
    index: 7,
    documentType: "RestrictionData",
    filename: "",
    expectedHeaders: [
      "item_code",
      "item_sales_invoice",
      "item_sales_returns",
      "item_purchase_request",
      "item_discontiue",
      "item_purchasing_order",
      "item_credit_note",
      "item_debit_note",
      "item_stock_in",
      "item_stock_out",
    ],
  },
  {
    index: 8,
    documentType: "RemarksData",
    filename: "",
    expectedHeaders: ["item_code", "item_remarks"],
  },
];
